<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            label-width="100px"
            class="queryform_div"
          >
            <el-row :gutter="24">
              <!-- <el-col :md="8" :sm="12" :xs="24">
              <el-form-item :label="$t('RunningTIme.FileName')">
                <el-input
                  style="width: 100%"
                  v-model="formselect.queryString"
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col> -->
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.productLine')">
                  <el-select
                    v-model="formselect.productLine"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in productLineArr"
                      :key="item.bnDictCode"
                      :label="item.bnDictName"
                      :value="item.bnDictCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12" :sm="12" :xs="24">
                <el-form-item
                  :label="$t('title.Datefrom')"
                  style="min-height: 41px"
                >
                  <el-date-picker
                    v-model="formselect.times"
                    type="monthrange"
                    align="right"
                    unlink-panels
                    :range-separator="$t('title.to')"
                    :start-placeholder="$t('title.beginDate')"
                    :end-placeholder="$t('title.endDate')"
                    style="width: 100%"
                    size="small"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="24" :xs="24" style="margin-top: 10px">
                <el-button
                  type="primary"
                  @click="getList('search')"
                  size="small"
                >
                  {{ $t("button.query") }}
                </el-button>
                <el-button @click="formselect.queryString = ''" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>
          <template>
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60px"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="month"
                  :label="$t('sim.month')"
                  min-width="120px"
                >
                  <!-- <template slot-scope="scope">
                    {{ "安装报表-"+brandCode+"-"+ scope.row.month}}
                  </template> -->
                </el-table-column>
                <!-- <el-table-column
                  prop="endTime"
                  :label="$t('el.datepicker.endTime')"
                  min-width="120px"
                >
                  <template slot-scope="scope">
                    {{ scope.row.endTime.split("T")[0] }}
                  </template>
                </el-table-column> -->
                <el-table-column :label="$t('title.operate')" width="90px">
                  <template slot-scope="scope">
                    <el-button
                      type="default"
                      icon="el-icon-download"
                      circle
                      size="mini"
                      :title="$t('RunningTIme.Download')"
                      v-show="hasDownLoadAuth"
                      @click="downloadPdf(scope.row)"
                    >
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next,sizes"
                :total="pagination.totalPage"
                :current-page.sync="pagination.current"
                :page-size="pagination.pageSize"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                style="text-align: center; margin-top: 10px"
              ></el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>

    <div :id="'pdfDom'" style="margin-top: -99999999px;width:1000px" class="pdfDiv">
      <div class="pdfHeader">
        <h4>{{pdfContent.title}}</h4>
        <img src="~assets/img/IRlogo.png" />
        <span class="sub">Origination Date: <strong>{{pdfContent.date}}</strong></span>
      </div>
      <div class="KPIDiv">
        <el-row :gutter="24">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" class="leftDiv">
            <el-row :gutter="24">
              <el-col :xs="24" :sm="12" :md="12" :lg="12">
                <div class="block homeCon">
                  <div class="LeftB" style="border-left-color: #28739a">
                    <h4>
                      {{ $t("desc.already_bind") }}
                      <el-button class="fr moreBtn" size="mini" type="text"
                        ><i class="el-icon-pie-chart"></i
                      ></el-button>
                    </h4>
                    <span
                      >{{ KPIData.BindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="divide"></div>
                  <div class="LeftB" style="border-left-color: #51a470">
                    <h4>{{ $t("desc.Connected_Active") }}</h4>
                    <span
                      >{{ KPIData.OnLineCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="LeftB" style="border-left-color: #cf554a">
                    <h4>{{ $t("desc.Connected_Offline") }}</h4>
                    <span
                      >{{ KPIData.OffLineCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12">
                <div class="block homeCon">
                  <div class="LeftB" style="border-left-color: #99a2ac">
                    <h4>{{ $t("desc.wait_bind") }}</h4>
                    <span
                      >{{ KPIData.WaitBindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="divide"></div>
            <el-row :gutter="24">
              <el-col :xs="24" :sm="12" :md="12" :lg="12">
                <div class="block homeCon">
                  <div class="LeftB" style="border-left-color: #28739a">
                    <h4>{{ $t("desc.IntegratedGSNCount") }}</h4>
                    <span
                      >{{ KPIData.IntegratedGSNCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="divide"></div>
                  <div class="LeftB" style="border-left-color: #99a2ac">
                    <h4>{{ $t("desc.IntegratedGSNWaitBindCount") }}</h4>
                    <span
                      >{{ KPIData.IntegratedGSNWaitBindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="LeftB" style="border-left-color: #28739a">
                    <h4>{{ $t("desc.IntegratedGSNBindCount") }}</h4>
                    <span
                      >{{ KPIData.IntegratedGSNBindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="divide"></div>
                  <div class="LeftB" style="border-left-color: #51a470">
                    <h4>{{ $t("desc.IntegratedGSNOnLineCount") }}</h4>
                    <span
                      >{{ KPIData.IntegratedGSNOnLineCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="LeftB" style="border-left-color: #cf554a">
                    <h4>{{ $t("desc.IntegratedGSNOffLineCount") }}</h4>
                    <span
                      >{{ KPIData.IntegratedGSNOffLineCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12">
                <div class="block homeCon">
                  <div class="LeftB" style="border-left-color: #28739a">
                    <h4>{{ $t("desc.IndependentGSNCount") }}</h4>
                    <span
                      >{{ KPIData.IndependentGSNCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="divide"></div>
                  <div class="LeftB" style="border-left-color: #99a2ac">
                    <h4>{{ $t("desc.IndependentGSNWaitBindCount") }}</h4>
                    <span
                      >{{ KPIData.IndependentGSNWaitBindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="LeftB" style="border-left-color: #28739a">
                    <h4>{{ $t("desc.IndependentGSNBindCount") }}</h4>
                    <span
                      >{{ KPIData.IndependentGSNBindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="divide"></div>
                  <div class="LeftB" style="border-left-color: #51a470">
                    <h4>{{ $t("desc.IndependentGSNOnLineCount") }}</h4>
                    <span
                      >{{ KPIData.IndependentGSNOnLineCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="LeftB" style="border-left-color: #cf554a">
                    <h4>{{ $t("desc.IndependentGSNOffLineCount") }}</h4>
                    <span
                      >{{ KPIData.IndependentGSNOffLineCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" class="rightDiv">
            <el-row :gutter="24">
              <el-col :xs="24" :sm="12" :md="12" :lg="12">
                <div class="block homeCon">
                  <div class="LeftB" style="border-left-color: #28739a">
                    <h4>{{ $t("desc.RetroFit") }}</h4>
                    <span
                      >{{ KPIData.LocalInstallCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="divide"></div>
                  <div class="LeftB" style="border-left-color: #99a2ac">
                    <h4>{{ $t("desc.RetroFitWaitBind") }}</h4>
                    <span
                      >{{ KPIData.LocalInstallWaitBindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="LeftB" style="border-left-color: #28739a">
                    <h4>{{ $t("desc.RetroFitBind") }}</h4>
                    <span
                      >{{ KPIData.LocalInstallBindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="divide"></div>
                  <div class="LeftB" style="border-left-color: #51a470">
                    <h4>{{ $t("desc.RetroFitOnLine") }}</h4>
                    <span
                      >{{ KPIData.LocalInstallOnLineCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="LeftB" style="border-left-color: #cf554a">
                    <h4>{{ $t("desc.RetroFitOffLine") }}</h4>
                    <span
                      >{{ KPIData.LocalInstallOffLineCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12">
                <div class="block homeCon">
                  <div class="LeftB" style="border-left-color: #28739a">
                    <h4>{{ $t("desc.FactoryFit") }}</h4>
                    <span
                      >{{ KPIData.FactoryInstallCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="divide"></div>
                  <div class="LeftB" style="border-left-color: #99a2ac">
                    <h4>{{ $t("desc.FactoryFitWaitBind") }}</h4>
                    <span
                      >{{ KPIData.FactoryInstallWaitBindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="LeftB" style="border-left-color: #28739a">
                    <h4>{{ $t("desc.FactoryFitBind") }}</h4>
                    <span
                      >{{ KPIData.FactoryInstallBindCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="divide"></div>
                  <div class="LeftB" style="border-left-color: #51a470">
                    <h4>{{ $t("desc.FactoryFitOnline") }}</h4>
                    <span
                      >{{ KPIData.FactoryInstallOnLineCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                  <div class="LeftB" style="border-left-color: #cf554a">
                    <h4>{{ $t("desc.FactoryFitOffline") }}</h4>
                    <span
                      >{{ KPIData.FactoryInstallOffLineCount
                      }}<small>{{ $t("desc.tai") }}</small></span
                    >
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="ReportDiv" style="padding-top: 600px;">
        <el-row :gutter="24">
          <el-col :md="12" :sm="24" :xs="24">
            <div class="block" style="position: relative; height: 300px">
              <h4>{{ $t("title.modelRatio") }}</h4>
              <div
                class="echarts"
                id="Kchart1a"
                style="
                  height: 330px;
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                "
              ></div>
            </div>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <div class="block" style="position: relative; height: 300px">
              <h4>{{ $t("title.industryRatio") }}</h4>
              <div
                class="echarts"
                id="Kchart2a"
                style="
                  height: 330px;
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                "
              ></div>
            </div>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <div class="block" style="position: relative; height: 300px">
              <h4>{{ $t("title.regionRatio") }}</h4>
              <div
                class="echarts"
                id="Kchart3a"
                style="
                  height: 330px;
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                "
              ></div>
            </div>
          </el-col>
          <el-col :md="12" :sm="24" :xs="24">
            <div class="block" style="position: relative; height: 300px">
              <h4>{{ $t("title.customCenterRatio") }}</h4>
              <div
                class="echarts"
                id="Kchart4a"
                style="
                  height: 330px;
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                "
              ></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import {
  getInstallReportList,
  authOperationCheck,
  getInstallReportData,
  getProductLines
} from "../../api/api";
export default {
  name: "index",

  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  data() {
    return {
      hasDownLoadAuth: false,
      tableData1: [],
      formselect: {
      },
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      KPIData: {},
      BlockH: {
        height: "",
        minHeight: "70px",
        // maxHeight:'100px',
      },

      DataDeviceType: [],
      DataDeviceTypeWarning: [],

      DataIndustry: [],
      DataIndustryWarning: [],

      DataArea: [],
      DataAreaWarning: [],

      DataCenter: [],
      DataCenterWarning: [],
      monthList: [],
      pdfContent:{
        title:"",
        date:""
      },
      brandCode:"",
      productLineArr:[],
    };
  },

  async mounted() {
    this.brandCode = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
    this.authOperation("InstallReport");
    await this.getProductLines();
    await this.getList();
  },
  methods: {
    async getProductLines(){
      let that=this;
      let res = await getProductLines();
      that.productLineArr = res.result;
      this.$set(this.formselect, "productLine", "Other")
    },
    async authOperation(curPage) {
      var that = this;
      var res = await authOperationCheck(curPage);
      that.hasDownLoadAuth = res.hasDownLoadAuth;
    },
    async getList(type = "normal") {
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        Times: that.formselect.times ? that.formselect.times : new Array(),
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
      };
      let res = await getInstallReportList(postData);
      let data = res.result.items;
      that.pagination.totalPage = res.result.totalCount;
      that.tableData1 = data;
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    SetHeight() {
      var mHeight = window.innerHeight - 300; //总高
      this.BlockH.height = mHeight / 3 - 10 + "px";
    },

    initPieDom(dom, data) {
      this.$nextTick(() => {
        var Kchart = this.$echarts.init(document.getElementById(dom));
        Kchart.setOption(this.initPie(data, this.$t("title.industryRatio")));
        window.addEventListener("resize", () => {
          Kchart.resize();
        });
      });
    },
    initBarDom(dom, data) {
      this.$nextTick(() => {
        var Kchart = this.$echarts.init(document.getElementById(dom));
        Kchart.setOption(this.initBar(data));
        window.addEventListener("resize", () => {
          Kchart.resize();
        });
      });
    },

    initPie(Data, name) {
    

      var temp = {
        toolbox: {
          right: 30,
          top: 24,
          feature: {
            saveAsImage: {
              type: "png",
              icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABpUlEQVQ4T92UIWwUQRSG/3+4NhU4BKKCeiSuioaEpAJHapqQq4PcbZsAitvZnd3ZQwFJu3cBx4WkhuAqmjRpisIh8SAQCByClGN+ciVt7mCPZqGKZ2fe9+a9/39DnHHwjHmYCiyKJ/PS7C1As5NFeUgevojjux+rHjMVmBflKwRdIfl+PFHSAgzfJnF0sxbQ+/IAwGtro2w80fsyBXDV2mjpPwA61z9vGt/XKc5IapIcVLV8fCbpWwjntpxrfTluf0KUong6HzR8B2AO5BsR3bTT3h+fVdbtXaPQgbQI4Kth43Ic3zlR/DeVs2xzicbs0piO7bQeVw3ed/v3FEJXISyn6cZIvJOotE2e91ZAbRuaZhy3tscTiqK/GhQGEFeTpP3y14JTfeh9GQl4ROiGtet7o0Tvt64L3CFw39qorGWb0eXMlw8JttEwPz03DAeCeqmNHkxb2VN3OS96zyEtHwHI3SRur/1p/08FOucaxlw4mlUIn1ecc8N/Atb9jSZe6H05AHCpJuSDtVGz0th5Xt4mcbEOUMKnJImeVQLrgP5a5bpFfgAK760Vi6b0CgAAAABJRU5ErkJggg==",
              iconStyle: {
                emphasis: {
                  textPosition: "left",
                  textFill: "#333",
                },
              },
              title: this.$t("desc.saveAsImage"),
              backgroundColor: "#242731"
            },
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
          show: false,
          position: "left",
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 10,
            fontFamily: "Arial",
          },
        },
        legend: {
          type: "scroll",
          icon: "circle",
          orient: "vertical",
          left: "45%",
          top: 90,
          bottom: 15,
          right: 30,
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 8,
          formatter: (name) => {
            return (
              // {name|' + item.name + '}
              "{name|" +
              this.$echarts.format.truncateText(name, 150, "…") +
              "} {percent|" +
              Data.find((item) => {
                return item.name == name;
              })?.value +
              "%" +
              "}"
            );
          },
          tooltip: {
            show: true,
          },
          textStyle: {
            color: "#beceff", //元字颜色
            fontSize: 14,
            rich: {
              name: {
                color: "#333",
                fontSize: 14,
                fontFamily: "Arial, 'microsoft yahei'",
                width: 150,
                align: "left",
              },
              percent: {
                color: "#333",
                fontSize: 14,
                fontFamily: "Arial, 'microsoft yahei'",
                width: 50,
                align: "right",
              },
            },
          },

          pageIconSize: 10,
          pageTextStyle: {
            color: "#828393",
          },
        },
        series: [
          // {
          //   name: name,
          //   type: "pie",
          //   radius: ["0%", "55%"],
          //   center: ["24%", "60%"],
          //   color: "#393C46",
          //   itemStyle: {
          //     normal: {
          //       label: {
          //         show: false,
          //       },
          //       labelLine: {
          //         show: false,
          //       },
          //     },
          //   },
          //   hoverAnimation: false,
          //   data: [
          //     {
          //       value: 1,
          //     },
          //   ],
          //   z: 1,
          // },
          {
            name: "",
            type: "pie",
            radius: ["0%", "55%"],
            center: ["24%", "60%"],
            color: this.Linecolor,
            data: Data,
            labelLine: {
              show: false,
              length: 20,
              length2: 30,
            },

            label: {
              show: false,
              color: "#333",
              lineHeight: 7,
              fontFamily: "Arial",
              formatter: function (params) {
                var percent = 0;
                var total = 0;
                for (var i = 0; i < Data.length; i++) {
                  total += Data[i].value;
                }
                percent = ((params.value / total) * 100).toFixed(0);
                if (params.name !== "") {
                  return params.name + ": " + percent + "%";
                } else {
                  return "";
                }
              },
            },
            z: 2,
          },
        ],
      };
      return temp;
    },
    initBar(Data) {
      var colorL = this.Linecolor;
      var temp = {
        toolbox: {
          right: 30,
          top: 24,
          feature: {
            saveAsImage: {
              type: "png",
              icon: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABpUlEQVQ4T92UIWwUQRSG/3+4NhU4BKKCeiSuioaEpAJHapqQq4PcbZsAitvZnd3ZQwFJu3cBx4WkhuAqmjRpisIh8SAQCByClGN+ciVt7mCPZqGKZ2fe9+a9/39DnHHwjHmYCiyKJ/PS7C1As5NFeUgevojjux+rHjMVmBflKwRdIfl+PFHSAgzfJnF0sxbQ+/IAwGtro2w80fsyBXDV2mjpPwA61z9vGt/XKc5IapIcVLV8fCbpWwjntpxrfTluf0KUong6HzR8B2AO5BsR3bTT3h+fVdbtXaPQgbQI4Kth43Ic3zlR/DeVs2xzicbs0piO7bQeVw3ed/v3FEJXISyn6cZIvJOotE2e91ZAbRuaZhy3tscTiqK/GhQGEFeTpP3y14JTfeh9GQl4ROiGtet7o0Tvt64L3CFw39qorGWb0eXMlw8JttEwPz03DAeCeqmNHkxb2VN3OS96zyEtHwHI3SRur/1p/08FOucaxlw4mlUIn1ecc8N/Atb9jSZe6H05AHCpJuSDtVGz0th5Xt4mcbEOUMKnJImeVQLrgP5a5bpFfgAK760Vi6b0CgAAAABJRU5ErkJggg==",
              iconStyle: {
                emphasis: {
                  textPosition: "left",
                  textFill: "#fff",
                },
              },
              title: this.$t("desc.saveAsImage"),
              backgroundColor: "#242731"
            },
          },
        },
        grid: {
          top: 100,
          left: 40,
          right: 30,
          bottom: 0,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: Data.map((item) => item.name),
            interval: 0,
            axisLabel: {
              textStyle: {
                margin: 5,
                color: "#828393",
                fontSize: 10,
                fontFamily: "Arial",
                lineHeight: 12,
              },
              interval: 0,
              formatter: function (params) {
                var newParamsName = ""; // 最终拼接成的字符串
                var paramsNameNumber = params.length; // 实际标签的个数
                var provideNumber = 6; // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ""; // 表示每一次截取的字符串
                    var start = p * provideNumber; // 开始截取的位置
                    var end = start + provideNumber; // 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr; // 最终拼成的字符串
                  }
                } else {
                  // 将旧标签的值赋给新标签
                  newParamsName = params;
                }
                //将最终的字符串返回
                return newParamsName;
              },
            },
            axisLine: {
              lineStyle: {
                color: "#D5D5D5",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 5,
            axisLabel: {
              textStyle: {
                color: "#828393",
                fontSize: 10,
                fontFamily: "Arial",
              },
              formatter: "{value} %",
            },
            axisLine: {
              lineStyle: {
                color: "#D5D5D5",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#D5D5D5",
              },
            },
            max: 100,
            min: 0,
          },
        ],

        series: [
          {
            name: "故障率",
            type: "bar",
            barWidth: "35%",
            data: Data.map((item) => item.value),
            label: {
              show: true,
              position: "top",
              formatter: "{c}%",
              fontFamily: "Arial",
              textStyle: {
                color: "#333",
              },
            },
            itemStyle: {
              normal: {
                barBorderRadius: [5, 5, 0, 0],
                color: "#28739A",
              },
            },
          },
        ],
      };
      return temp;
    },
    async downloadPdf(row) {
      let that = this;
      let date =
        row.startTime.split("-")[0] + "-" + row.startTime.split("-")[1];
      that.monthList = [date, date];
      let pdfTitle="";
      if (this.activeLang=="zh"){
        that.pdfContent.title = "安装报表-"+this.brandCode+"-"+row.startTime.split("-")[0] + "年" + row.startTime.split("-")[1]+"月";
        pdfTitle = "安装报表-"+this.brandCode+"-"+row.startTime.split("-")[0] + "-" + row.startTime.split("-")[1];
      }else{
        that.pdfContent.title = "Install Report-"+this.brandCode+"-"+row.startTime.split("-")[0] + "-" + row.startTime.split("-")[1];
        pdfTitle = "InstallReport-"+this.brandCode+"-"+row.startTime.split("-")[0] + "-" + row.startTime.split("-")[1];
      }
      await that.getPdfData(row.startTime);
      
      setTimeout(() => {
        that.getPdf(pdfTitle);
      }, 1000);
    },
    async getPdfData(startTime){
      let that = this;
      let postData = {
        ReportMonth: startTime,
        ProductLine: this.formselect.productLine
      }
      let res = await getInstallReportData(postData);
      that.pdfContent.date = res.result.lastModificationTime?res.result.lastModificationTime.replace('T',' ').split('.')[0]:res.result.creationTime.replace('T',' ').split('.')[0];
      this.KPIData = JSON.parse(res.result.deviceKPIJson);
      let chartData = JSON.parse(res.result.chartJson);
      let deviceModelRate = chartData.DeviceModelRate.RateBarList;
      console.log(deviceModelRate)
      if(this.activeLang != 'zh'){
        deviceModelRate.forEach((item)=>{item.name = item.nameEn})
      }
      let industryRate = chartData.IndustryRate.RateBarList;
      if(this.activeLang != 'zh'){
        industryRate.forEach((item)=>{item.name = item.nameEn})
      }
      let regioRate = chartData.RegioRate.RateBarList;
      if(this.activeLang != 'zh'){
        regioRate.forEach((item)=>{item.name = item.nameEn})
      }
      let centerRate = chartData.CenterRate.RateBarList;
      if(this.activeLang != 'zh'){
        centerRate.forEach((item)=>{item.name = item.nameEn})
      }
      this.initPieDom("Kchart1a", deviceModelRate);
      this.initPieDom("Kchart2a", industryRate);
      this.initPieDom("Kchart3a", regioRate);
      this.initPieDom("Kchart4a", centerRate);
    }
  },
  created() {
    window.addEventListener("resize", this.SetHeight);
    var _self = this;
    this.$nextTick(() => {
      _self.SetHeight();
    });
  },
};
</script>
<style lang="less" scoped>
.theme1 {
  .leftDiv {
    padding-right: 20px !important;
    border-right: 1px solid #d5d5d5;
  }
  .rightDiv {
    padding-left: 20px !important;
    border-left: 1px solid #d5d5d5;
    margin-left: -1px;
  }
  .block {
    span {
      cursor: pointer;
    }
  }
}

@media (max-width: 991px) {
  .theme1 .leftDiv {
    padding-right: 10px !important;
  }
  .theme1 .rightDiv {
    padding-left: 10px !important;
    border-left: 0;
  }
}
</style>


